export enum VehicleOwnershipStatusType {
  OWNED = "OWNED",
  RENTAL = "RENTAL"
}
